// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading___pYuK","NoBorder":"styles_NoBorder__MlsE5"};